import React from 'react'
import PropTypes from 'prop-types'

import { Avatar, Box, Flex, Header } from 'ui/acro'

const CoachList = ({ coaches }) => (
  <Flex flexWrap='wrap' mb={['18px']} justifyContent='flex-start'>
    {coaches.map((coach, idx) => (
      <Flex
        key={idx}
        alignItems='center'
        justifyContent={['center']}
        mb={['5px', '10px']}
      >
        <Box as='a' href={`/instructors/${coach.slug}`} className='unstyled'>
          <Avatar
            src={coach.profilePhoto.normal.url}
            width={['24px', '32px']}
            height={['24px', '32px']}
          />
        </Box>
        <Header
          as='a'
          href={`/instructors/${coach.slug}`}
          lineHeight='105%'
          ml={['8px', '10px']}
          mr={['16px', '22px']}
        >
          {coach.firstName} {coach.lastName}
        </Header>
      </Flex>
    ))}
  </Flex>
)

CoachList.propTypes = {
  coaches: PropTypes.array
}

export default CoachList
